'use client';

import {usePathname} from 'next/navigation';
import {useEffect} from 'react';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EventName} from '@web-landing/analytics/events';

export default function PageViewLogger({
  pageViewEventName,
}: {
  pageViewEventName?: EventName;
}) {
  const pathname = usePathname();

  useEffect(() => {
    if (pageViewEventName) {
      setTimeout(() => {
        logTmrEvent(pageViewEventName, {
          pageURL: `https://www.rustore.ru${pathname}`,
        });
      }, 0);
    }
  }, [pageViewEventName, pathname]);

  return null;
}
